module.exports = __webpack_public_path__ + "static/img/logo.771c5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qxr/logo.png
// module id = 9kgX
// module chunks = 51